import { Eye } from 'lucide-react';
import { classNames } from '../../../../helpers/classNames';

/**
 * Top-of-step callout for photos the automatic crop marked "Worth a look"
 * (cropReview.flagged). Plain words for a parent or grandparent: what the
 * badge means and what to do. Never blocks anything; it goes away as the
 * marked photos get a saved crop. Amber, per docs/design/HANDOFF.md.
 */
const WorthALookNotice = ({ count = 0, isCover = false, className }) => {
  if (!count) return null;

  const body = isCover ? (
    <>We weren&rsquo;t sure how to crop your cover photo. Tap it to double check.</>
  ) : (
    <>
      {/* Phones: one line at 390px (decided 2026-10-29); the photos carry an eye badge there, not the label. */}
      <span className="md:hidden">
        Check the crop on the <strong>{count === 1 ? '1 marked photo' : `${count} marked photos`}</strong>
      </span>
      <span className="hidden md:inline">
        We weren&rsquo;t sure how to crop {count === 1 ? '1 photo' : `${count} photos`}.{' '}
        <span className="lg:hidden">Tap</span>
        <span className="hidden lg:inline">Click</span> any marked <strong>Worth a look</strong> to check.
      </span>
    </>
  );

  return (
    <div
      role="status"
      className={classNames(
        'flex items-start gap-2.5 rounded-xl border border-amber-300 bg-amber-50 px-3 py-2.5 text-sm leading-snug text-amber-950',
        className,
      )}
    >
      <Eye className="mt-0.5 h-4 w-4 flex-shrink-0 text-amber-700" aria-hidden="true" />
      <span>{body}</span>
    </div>
  );
};

export default WorthALookNotice;
